import { useSelector } from 'react-redux';
import { MyHouseBanner } from 'shared/components/MyHouseBanner';
import { Section } from 'shared/components/Section';
import { selectMyHouseBannerLink } from 'shared/selectors/myHouseBanner';
import { trackBannerClick } from './tracking';

export const MyHouseBannerContainer = () => {
  const myHouseBannerLink = useSelector(selectMyHouseBannerLink);

  if (!myHouseBannerLink) {
    return null;
  }

  return (
    <Section>
      <MyHouseBanner link={myHouseBannerLink} onClick={trackBannerClick} />
    </Section>
  );
};
